module.exports = __webpack_public_path__ + "static/img/home-new6.9584fc02.jpg";